import { render, staticRenderFns } from "./ModalFormsDownloadEdit.vue?vue&type=template&id=00abb36f&"
import script from "./ModalFormsDownloadEdit.vue?vue&type=script&lang=js&"
export * from "./ModalFormsDownloadEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports